"use strict"

import { EnvStage } from "common-library/ucountit-env"
import { createApiUrls } from "./apiurls"
import { Optional, Required } from "./Environment"

const hostname = "uk.retailtrend.net"
const bucket = "vca.earlgrey"
const region = "eu-west-2"
const config: EnvStage<Required, Optional> = {
  brand: "ukrt",
  host: [hostname],
  api: Object.assign(createApiUrls(hostname), {
    trackurl: `http://${hostname}:19521/api/v1`,
    faceurl: `http://${hostname}:19509/api/v1`,
  }),

  web: {
    faceurl: "/facedashboard",
    tunnelUrl: `http://tunnel-${hostname}`,
  },

  log: {
    analyticTrackingId: "G-2GP4KNFPP6",
  },

  s3: {
    static: {
      bucket,
      destination: "static",
      region,
      cloudfront: "",
    },
    firmware: {
      bucket,
      destination: "firmware",
      region,
    },
    face: {
      bucket,
      destination: "face",
      region,
    },
    customAgency: {
      bucket,
      destination: "customAgency",
      region,
    },
  },

  cloudFront: {
    bucket,
    region,
    prefix: "ui",
    basePath: "https://cdn-uk.retailtrend.net",
  },

  email: {
    from: "notification@retailtrend.net",
  },

  jobTunnels: {
    startPort: 28000,
    endPort: 29995,
  },

  address: {
    key: "U01TX0FVVEgyMDI1MTAyMTEyMTcwMzExNjM0ODE=",
  },

  isUkrt: true,
}

export default config
